import { Id } from '@vimeo/core/types/generic';

import { EChatType } from '../../types/interaction_tools';

const DRAFT_KEY_PREFIX: string = 'vimeo.live.chat-draft';

function getKey(sessionId: Id, chatType: EChatType): string {
  return `${DRAFT_KEY_PREFIX}:${sessionId}:${chatType}`;
}

function getStorage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch {
    return null;
  }
}

export function readDraft(sessionId: Id, chatType: EChatType): string {
  const storage: Storage | null = getStorage();

  if (!storage) return '';

  try {
    return storage.getItem(getKey(sessionId, chatType)) || '';
  } catch {
    return '';
  }
}

export function writeDraft(sessionId: Id, chatType: EChatType, value: string): void {
  const storage: Storage | null = getStorage();

  if (!storage) return;

  try {
    if (value) {
      storage.setItem(getKey(sessionId, chatType), value);
    } else {
      storage.removeItem(getKey(sessionId, chatType));
    }
  } catch {
    // sessionStorage may throw on quota exceeded or in private mode; ignore.
  }
}
